import React, { FC } from 'react'
import styles from 'styles/components/tab.module.scss'
import Tab from './Tab'

type Props = {
  tabs: {
    isSelected: boolean
    label: string
    onClick?: () => void
    url: string
  }[]
}

const Tabs: FC<Props> = (props) => {
  const { tabs } = props
  return (
    <div className={styles.tab__container}>
      <div className={styles.tab__inner}>
        {tabs.map((tab) => (
          <Tab key={tab.label} isSelected={tab.isSelected} label={tab.label} onClick={tab.onClick} url={tab.url} />
        ))}
      </div>
    </div>
  )
}

export default Tabs
